import styled from "styled-components";
import { device } from "./Device";

export const PopupForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  gap: 5vh;
  padding: 2vh 0;

  @media ${device.laptop} {
    gap: 8vh;
  }
`;
